// Fonte UNICA dos menus de admin do topo (Relatorios / Brain / Marketing /
// Config). O TopBar (desktop) filtra por permissao com filterSections; a
// MobileTabBar (celular) consome os mesmos dados na folha "Mais" — assim
// os dois nunca divergem. Dados puros: cada builder recebe { t,
// accountScopedRoute } e devolve [{ title, items: [{ label, icon, link }] }].

export const buildReportsSections = ({ t, accountScopedRoute }) => [
  {
    title: t('TOPBAR.OVERVIEW'),
    items: [
      {
        label: t('TOPBAR.LIVE_DASHBOARD'),
        icon: 'i-lucide-activity',
        link: accountScopedRoute('account_overview_reports'),
      },
      {
        label: t('SIDEBAR.CONVERSATIONS'),
        icon: 'i-lucide-message-square',
        link: accountScopedRoute('conversation_reports'),
      },
    ],
  },
  {
    title: t('TOPBAR.PERFORMANCE'),
    items: [
      {
        label: t('TOPBAR.AGENTS'),
        icon: 'i-lucide-user',
        link: accountScopedRoute('agent_reports_index'),
      },
      {
        label: t('TOPBAR.INBOXES'),
        icon: 'i-lucide-inbox',
        link: accountScopedRoute('inbox_reports_index'),
      },
      {
        label: t('TOPBAR.TEAMS'),
        icon: 'i-lucide-users',
        link: accountScopedRoute('team_reports_index'),
      },
      {
        label: t('SIDEBAR.LABELS'),
        icon: 'i-lucide-tags',
        link: accountScopedRoute('label_reports_index'),
      },
    ],
  },
  {
    title: t('TOPBAR.SATISFACTION_SLA'),
    items: [
      {
        label: 'CSAT',
        icon: 'i-lucide-smile',
        link: accountScopedRoute('csat_reports'),
      },
      {
        label: 'SLA',
        icon: 'i-lucide-timer',
        link: accountScopedRoute('sla_reports'),
      },
    ],
  },
  {
    title: t('TOPBAR.OTHERS'),
    items: [
      {
        label: 'Brain',
        icon: 'i-lucide-brain',
        link: accountScopedRoute('bot_reports'),
      },
      {
        label: t('SIDEBAR.CRM'),
        icon: 'i-lucide-briefcase',
        link: accountScopedRoute('crm_reports'),
      },
      {
        label: 'Campanhas',
        icon: 'i-lucide-megaphone',
        link: accountScopedRoute('campaigns_reports'),
      },
      {
        label: 'Landing Pages',
        icon: 'i-lucide-panels-top-left',
        link: accountScopedRoute('landing_pages_reports'),
      },
    ],
  },
];

export const buildCaptainSections = ({ t, accountScopedRoute }) => [
  {
    title: '',
    items: [
      {
        label: t('CAPTAIN.BRAIN.AREA_TABS.OVERVIEW'),
        icon: 'i-lucide-layout-dashboard',
        link: accountScopedRoute('brain_overview'),
      },
      {
        label: t('CAPTAIN.BRAIN.AREA_TABS.AGENTS'),
        icon: 'i-lucide-bot',
        link: accountScopedRoute('brain_assistants_index'),
      },
      {
        label: t('CAPTAIN.BRAIN.AREA_TABS.KNOWLEDGE'),
        icon: 'i-lucide-book-open',
        link: accountScopedRoute('brain_knowledge_bases_index'),
      },
      {
        label: t('CAPTAIN.BRAIN.AREA_TABS.COPILOT'),
        icon: 'i-lucide-message-square-plus',
        link: accountScopedRoute('brain_copilot'),
      },
      {
        label: t('CAPTAIN.BRAIN.AREA_TABS.CONFIG'),
        icon: 'i-lucide-settings',
        link: accountScopedRoute('brain_config'),
      },
    ],
  },
];

export const buildMarketingSections = ({ t, accountScopedRoute }) => [
  {
    title: t('TOPBAR.CAMPAIGNS'),
    items: [
      {
        label: t('TOPBAR.CAMPAIGNS'),
        icon: 'i-lucide-list',
        link: accountScopedRoute('campaigns_index'),
      },
      {
        label: t('TOPBAR.MARKETING_FLOWS'),
        icon: 'i-lucide-git-fork',
        link: accountScopedRoute('marketing_flows_index'),
      },
      // E-mail nao entra aqui: ele e um CANAL dos disparos em massa, e a
      // navegacao por canal ja vive dentro daquela tela.
      {
        label: t('TOPBAR.BROADCASTS'),
        icon: 'i-lucide-megaphone',
        link: accountScopedRoute('broadcasts_list'),
      },
    ],
  },
  {
    title: t('TOPBAR.SECTION_ACQUISITION'),
    items: [
      {
        label: t('TOPBAR.LANDING_PAGES'),
        icon: 'i-lucide-panels-top-left',
        link: accountScopedRoute('settings_landing_pages'),
      },
      {
        label: t('TOPBAR.SITES'),
        icon: 'i-lucide-globe',
        link: accountScopedRoute('settings_sites'),
      },
      {
        label: t('SIDEBAR.FORMS'),
        icon: 'i-lucide-file-text',
        link: accountScopedRoute('forms_index'),
      },
      {
        label: t('SIDEBAR.CONVERSIONS'),
        icon: 'i-lucide-zap',
        link: accountScopedRoute('conversions_index'),
      },
    ],
  },
  {
    title: t('SIDEBAR.SOCIAL'),
    items: [
      {
        label: t('SIDEBAR.SOCIAL'),
        icon: 'i-lucide-at-sign',
        link: accountScopedRoute('social_dashboard'),
      },
      {
        label: t('SIDEBAR.GOOGLE_REVIEWS'),
        icon: 'i-lucide-star',
        link: accountScopedRoute('social_google_reviews'),
      },
    ],
  },
  {
    title: t('TOPBAR.SECTION_SOURCES'),
    items: [
      {
        label: t('TOPBAR.ADS_MANAGER'),
        icon: 'i-lucide-radio-tower',
        link: accountScopedRoute('settings_meta_ads'),
      },
    ],
  },
];

export const buildSettingsSections = ({ t, accountScopedRoute }) => [
  {
    title: t('TOPBAR.ACCOUNT'),
    items: [
      {
        label: t('TOPBAR.ACCOUNT'),
        icon: 'i-lucide-building-2',
        link: accountScopedRoute('general_settings_index'),
      },
      {
        label: t('TOPBAR.BILLING'),
        icon: 'i-lucide-credit-card',
        link: accountScopedRoute('billing_settings_index'),
      },
      {
        label: t('TOPBAR.SECURITY'),
        icon: 'i-lucide-lock',
        link: accountScopedRoute('security_settings_index'),
      },
      {
        label: t('TOPBAR.AUDIT'),
        icon: 'i-lucide-shield-check',
        link: accountScopedRoute('auditlogs_list'),
      },
    ],
  },
  {
    title: t('TOPBAR.SECTION_PEOPLE_CHANNELS'),
    items: [
      {
        label: t('TOPBAR.AGENTS'),
        icon: 'i-lucide-user',
        link: accountScopedRoute('agent_list'),
      },
      {
        label: t('TOPBAR.TEAMS'),
        icon: 'i-lucide-users',
        link: accountScopedRoute('settings_teams_list'),
      },
      {
        label: t('TOPBAR.ROLES'),
        icon: 'i-lucide-shield',
        link: accountScopedRoute('custom_roles_list'),
      },
      {
        label: t('TOPBAR.INBOXES'),
        icon: 'i-lucide-inbox',
        link: accountScopedRoute('settings_inbox_list'),
      },
    ],
  },
  {
    title: t('TOPBAR.SECTION_SERVICE'),
    items: [
      {
        label: 'SLA',
        icon: 'i-lucide-timer',
        link: accountScopedRoute('sla_list'),
      },
      {
        label: t('TOPBAR.ASSIGNMENT_POLICY'),
        icon: 'i-lucide-user-check',
        link: accountScopedRoute('assignment_policy_index'),
      },
      {
        label: t('TOPBAR.ATTRIBUTES'),
        icon: 'i-lucide-list',
        link: accountScopedRoute('attributes_list'),
      },
      {
        label: t('TOPBAR.CONVERSATION_RESOLUTION'),
        icon: 'i-lucide-check-circle-2',
        link: accountScopedRoute('conversation_workflow_index'),
      },
      {
        label: t('TOPBAR.TICKET_PIPELINES'),
        icon: 'i-lucide-life-buoy',
        link: accountScopedRoute('crm_ticket_funnels'),
      },
    ],
  },
  {
    title: t('SIDEBAR.CRM'),
    items: [
      {
        label: 'Pipelines',
        icon: 'i-lucide-git-branch',
        link: accountScopedRoute('crm_funnels'),
      },
    ],
  },
  {
    title: t('TOPBAR.AUTOMATION'),
    items: [
      {
        label: 'Workflows',
        icon: 'i-lucide-workflow',
        link: accountScopedRoute('workflows_index'),
      },
      {
        label: t('TOPBAR.SCHEDULES'),
        icon: 'i-lucide-calendar-clock',
        link: accountScopedRoute('scheduled_messages_list'),
      },
    ],
  },
  {
    title: t('TOPBAR.INTEGRATIONS'),
    items: [
      {
        label: t('TOPBAR.INTEGRATIONS'),
        icon: 'i-lucide-puzzle',
        link: accountScopedRoute('settings_applications'),
      },
      {
        label: 'Webhooks',
        icon: 'i-lucide-webhook',
        link: accountScopedRoute('settings_integrations_webhook'),
      },
    ],
  },
];
